export const priceRanges = [['3M',3],['6M',6],['1Y',12],['3Y',36],['5Y',60],['Max',null]];
const DAY = 86400000;

// Keep date-only market sessions in UTC, independent of the viewer's timezone.
export function normalizePriceHistory(rows, {now = Date.now()} = {}) {
  const today = new Date(now).toISOString().slice(0,10);
  const days = new Map();
  for (const row of Array.isArray(rows) ? rows : []) {
    const date = String(row?.date || '').slice(0,10);
    const time = Date.parse(`${date}T00:00:00Z`);
    if (!/^\d{4}-\d{2}-\d{2}$/.test(date) || !Number.isFinite(time) || new Date(time).toISOString().slice(0,10) !== date || date > today) continue;
    if (row.close == null || String(row.close).trim() === '' || !Number.isFinite(Number(row.close)) || Number(row.close) <= 0) continue;
    if (row.verification_status && row.verification_status !== 'VERIFIED') continue;
    const volume = row.volume == null || String(row.volume).trim() === '' ? null : Number(row.volume);
    if (!days.has(date)) days.set(date, {...row,date,close:Number(row.close),volume:Number.isFinite(volume) && volume >= 0 ? volume : null,time});
  }
  return [...days.values()].sort((a,b)=>a.time-b.time);
}

function weekStart(time) {
  const date = new Date(time);
  return time - ((date.getUTCDay()+6)%7)*DAY;
}

// Use the last available close in each calendar week, including the current week
// as-of each point. This matches the market summary, rather than a 600-day proxy.
export function weeklyMovingAverage(rows, window = 120) {
  const weeks = [];
  let sum = 0;
  return rows.map(row => {
    const week = weekStart(row.time);
    if (weeks.at(-1)?.week === week) {
      sum += row.close - weeks.at(-1).close;
      weeks[weeks.length-1] = {week,close:row.close};
    } else {
      weeks.push({week,close:row.close});
      sum += row.close;
      if (weeks.length > window) sum -= weeks.shift().close;
    }
    return weeks.length === window && week - weeks[0].week === (window-1)*7*DAY ? sum/window : null;
  });
}

export function selectPriceRange(rows, range = '1Y', options) {
  const all = normalizePriceHistory(rows, options);
  if (!all.length) return {all,data:[],ma:[],limited:false};
  const months = priceRanges.find(([label])=>label===range)?.[1];
  const end = new Date(all.at(-1).time);
  let cutoff = all[0].time;
  if (months != null) {
    const day = end.getUTCDate();
    end.setUTCDate(1);
    end.setUTCMonth(end.getUTCMonth()-months);
    const lastDay = new Date(Date.UTC(end.getUTCFullYear(),end.getUTCMonth()+1,0)).getUTCDate();
    end.setUTCDate(Math.min(day,lastDay));
    cutoff = end.getTime();
  }
  const start = all.findIndex(row=>row.time>=cutoff);
  return {all,data:all.slice(start),ma:weeklyMovingAverage(all).slice(start),limited:months != null && all[0].time>cutoff+7*DAY};
}

export function priceHistoryLabel(status) {
  if (status === 'PROTOTYPE') return 'Reference illustration · not live market data';
  if (status === 'VERIFIED') return 'Verified price history';
  if (status === 'HISTORICAL') return 'Historical price data · current quote unavailable';
  return 'Price history · verification pending';
}
